module.exports = __webpack_public_path__ + "static/media/ANIVERSARIO_large.f972c115.png";